import React from 'react';
import styles from './css/index.module.css';

const AiWardenKeypointsPanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Extract high-signal, diligence-relevant key points from the selected scope (including why each point matters, citations, and evidence limits).
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Extract Keypoints'}
                </button>
                <span className={styles.aiWardenTip}>Output uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenKeypointsPanel;
